// export default r => require.ensure([], () => r(require('@v/layout')), 'layout')


export default () => import(/* webpackChunkName: "layout"*/ '@v/layout')